import React from 'react';
import PropTypes from 'prop-types';
import apiSettings from '../../../../config/api';
import appConst from '../../../../config/const';

const TourImage = (props) => {

  const createSrcPath = (images, size) => {
    let src = '/assets/img/noimage.png';
    if (images && images[0]) {
      const img = images[0];
      if (img && img.preview) {
        src = img.preview;
      }
      if (img && img[appConst.PHOTOS[size]] && img.updatedAt) {
        src = apiSettings.endpoints.genImageUrl(img[appConst.PHOTOS[size]], img.updatedAt);
      }
    }
    return src;
  };

  const {
    images,
    onClick
  } = props;

  return (
    <div
      className="booking__img-block"
      onClick={onClick}
      role="presentation"
      onKeyDown={() => {
      }}
    >
      <img
        src={createSrcPath(images, 'small')}
        alt="Tour Im"
      />
    </div>
  )
};

TourImage.propTypes = {
  images: PropTypes.array,
  onClick: PropTypes.func,
};

export default TourImage;


// WEBPACK FOOTER //
// ./src/app/containers/Booking/components/Block/Image.js